import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalConstants } from 'src/app/common/constants/global.constant';
import { TilesDetails } from 'src/app/core/interfaces/library-v2-data.i';
import { LibraryV2DataService } from 'src/app/core/services/library-v2/library-v2-data.service';
import { QrCodeService } from 'src/app/core/services/qr-input-service/qr-input.service';

@Component({
  selector: 'app-panther-lake-overview',
  templateUrl: './panther-lake-overview.component.html',
  styleUrls: ['./panther-lake-overview.component.scss']
})
export class PantherLakeOverviewComponent implements OnInit {
  overviewLibraryContent: TilesDetails[];
  ptlVAHomePageText: any;
  ptlHomePageText:string;
  ptlType: string;
  language: string;
  vaSearchSendIcon: any;
  setIntelDisplayOneFont: boolean;
  constructor(
    private router: Router,
    private libraryService: LibraryV2DataService,
    private qrCodeService: QrCodeService
  ) { }

  ngOnInit(): void {
    this.ptlVAHomePageText = this.libraryService.getStaticText('tr_VAHomepageText'); 
    if(this.qrCodeService?.isPantherLakeStd){
      this.ptlHomePageText = this.libraryService.getStaticText('tr_PTLHomePageText');
      this.ptlType = GlobalConstants.PANTHER_LAKE;
      this.vaSearchSendIcon = this.ptlVAHomePageText?.ptl_VASearchSendIcon
    } else if(this.qrCodeService?.isPantherLake12Xe) {
      this.ptlHomePageText = this.libraryService.getStaticText('tr_PTL12XEHomePageText');
      this.ptlType = GlobalConstants.PANTHER_LAKE_12XE;
      this.vaSearchSendIcon = this.ptlVAHomePageText?.ptl12xe_VASearchSendIcon;
    }
    this.overviewLibraryContent = this.libraryService.getTilesData(this.ptlType, GlobalConstants.DEFAULT_TYPE);
    if (!this.isSoftwareBundleTileEnabled()) {
      this.overviewLibraryContent = this.overviewLibraryContent.filter(tile => tile.tileUrlName !== 'ptl-softwarebundle');
	  }
    const qrData = this.qrCodeService.getQrData();
    this.language = qrData.Language;
    this.setIntelDisplayOneFont = this.qrCodeService.setenusLang();
  }

  routeToTab(queryParam : string) {
    this.router.navigate([], {
          queryParams: { activeTab: queryParam },
        });
  }

  routeToTileDetailsPage(tileUrl: string) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>{ 
          this.router.navigate(['/specs/' + tileUrl]);
  });
  }
  
  private isSoftwareBundleTileEnabled(): boolean {
   const expiryDate = new Date(GlobalConstants.SW_BUNDLE_CUTOFF_END_DATE);
	  return new Date() < expiryDate;
  }

}
